@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.reapply-wrapper {
  width: 100%;
}

:global(.header-txt).reapply-header {
  text-align: center;
  margin-top: 1.25em;
  line-height: 33px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 1.5em;
  }
}

.reapply-info-wrapper {
  margin-bottom: 2em;
}

.reapply-body {
  color: colors.$body-text;
}

// Flexpay
:global(.flexpay) {
  :global(.header-txt).reapply-header {
    text-align: left;
  }
}
